import { DateTime } from 'luxon';
import * as Icons24 from 'dg-web-shared/ui/icons/Icons24.tsx';

export type { LicensePlate } from 'dg-web-shared/dto/LicensePlate.ts';

export enum PermitStatus {
    active = 'active',
    future = 'future',
    expired = 'expired',
    stornod = 'stornod',
    credited = 'credited',
}

interface PermitDates {
    validFrom: string;
    validTo: string;
}

export function isActive(p: PermitDates): boolean {
    const now = DateTime.now();
    const from = DateTime.fromISO(p.validFrom);
    const to = DateTime.fromISO(p.validTo);
    return now >= from && now <= to;
}

export const isFuture = (p: PermitDates): boolean => {
    const now = DateTime.now();
    const from = DateTime.fromISO(p.validFrom);
    const to = DateTime.fromISO(p.validTo);
    return from > now && to > now && !isStornod(p);
};

export const isExpired = (p: PermitDates): boolean =>
    DateTime.fromISO(p.validTo) < DateTime.now() && !isStornod(p);

export const isStornod = (p: PermitDates): boolean => p.validTo === p.validFrom;

export const permitStatusString = (p: PermitDates) =>
    isActive(p)
        ? PermitStatus.active
        : isStornod(p)
          ? PermitStatus.stornod
          : isFuture(p)
            ? PermitStatus.future
            : PermitStatus.expired;

export const permitStatusIcon = (p: PermitDates) =>
    isActive(p)
        ? Icons24.permitState.active
        : isStornod(p)
          ? Icons24.permitState.canceled
          : isFuture(p)
            ? Icons24.permitState.future
            : Icons24.permitState.expired;
